import {
  usePlaybook,
  UsePlaybookOptions,
} from '@/shared/hooks/data-hooks/playbooks/usePlaybook'
import { keepPreviousData, useQueryClient } from '@tanstack/react-query'
import React, { useEffect, useState } from 'react'
import { PlaybookQueryContext } from '../contexts/playbookQueryContext'

type PlaybookQueryProviderProps = {
  playbookId: string
  children: React.ReactNode
  queryOptions?: UsePlaybookOptions['queryOptions']
}

export const PlaybookQueryProvider: React.FC<PlaybookQueryProviderProps> = ({
  playbookId,
  children,
  queryOptions,
}) => {
  const queryClient = useQueryClient()
  const queryResult = usePlaybook({
    id: playbookId,
    queryOptions: {
      placeholderData: keepPreviousData,
      ...queryOptions,
    },
  })

  const [title, setTitleState] = useState<string | undefined>(
    queryResult.data?.data?.title
  )

  const setTitle = (title: string) => {
    setTitleState(title)
    queryClient.invalidateQueries({
      queryKey: ['playbooks', playbookId],
      exact: false,
    })
  }

  useEffect(() => {
    if (queryResult.data?.data?.title) {
      setTitleState(queryResult.data.data.title)
    }
  }, [queryResult.data?.data?.title, playbookId, queryClient])

  const value = {
    ...queryResult,
    title,
    setTitle,
  }

  return (
    <PlaybookQueryContext.Provider value={value}>
      {children}
    </PlaybookQueryContext.Provider>
  )
}
